import React, { Component } from "react";
import {
  CheckStepByStepContainer,
  CheckStepByStepContainerBlocks,
  CheckStepByStepContainerBlocksBlock,
  CheckStepByStepContainerBlocksBlockDescription,
  CheckStepByStepContainerBlocksBlockStep,
  CheckStepByStepContainerBlocksBlockSubtitle,
  CheckStepByStepContainerBlocksSubtitle,
  CheckStepByStepContainerContentDivisor,
} from "./styles";

class ScoreStepByStep extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <CheckStepByStepContainer>
          <CheckStepByStepContainerBlocks>
            <CheckStepByStepContainerBlocksBlock>
              <CheckStepByStepContainerBlocksBlockStep>
                <h1>1</h1>
              </CheckStepByStepContainerBlocksBlockStep>
            </CheckStepByStepContainerBlocksBlock>

            <CheckStepByStepContainerContentDivisor>
              <div className={this.props.step > 1 ? "" : "linegray"}></div>
            </CheckStepByStepContainerContentDivisor>

            <CheckStepByStepContainerBlocksBlock>
              <CheckStepByStepContainerBlocksBlockStep>
                <div className={this.props.step >= 2 ? "" : "circlegray"}>
                  <h1>2</h1>
                </div>
              </CheckStepByStepContainerBlocksBlockStep>
            </CheckStepByStepContainerBlocksBlock>
            <CheckStepByStepContainerContentDivisor>
              <div className={this.props.step > 2 ? "" : "linegray"}></div>
            </CheckStepByStepContainerContentDivisor>

            <CheckStepByStepContainerBlocksBlock>
              <CheckStepByStepContainerBlocksBlockStep>
                <div className={this.props.step >= 3 ? "" : "circlegray"}>
                  <h1>3</h1>
                </div>
              </CheckStepByStepContainerBlocksBlockStep>
            </CheckStepByStepContainerBlocksBlock>

            <CheckStepByStepContainerContentDivisor>
              <div className={this.props.step > 3 ? "" : "linegray"}></div>
            </CheckStepByStepContainerContentDivisor>

            <CheckStepByStepContainerBlocksBlock>
              <CheckStepByStepContainerBlocksBlockStep>
                <div className={this.props.step >= 4 ? "" : "circlegray"}>
                  <h1>4</h1>
                </div>
              </CheckStepByStepContainerBlocksBlockStep>
            </CheckStepByStepContainerBlocksBlock>

            <CheckStepByStepContainerContentDivisor>
              <div className={this.props.step > 4 ? "" : "linegray"}></div>
            </CheckStepByStepContainerContentDivisor>

            <CheckStepByStepContainerBlocksBlock>
              <CheckStepByStepContainerBlocksBlockStep>
                <div className={this.props.step >= 5 ? "" : "circlegray"}>
                  <h1>5</h1>
                </div>
              </CheckStepByStepContainerBlocksBlockStep>
            </CheckStepByStepContainerBlocksBlock>
          </CheckStepByStepContainerBlocks>
        </CheckStepByStepContainer>
        <div>
          <CheckStepByStepContainerBlocksSubtitle>
            <CheckStepByStepContainerBlocksBlockSubtitle>
              <CheckStepByStepContainerBlocksBlockDescription>
                <p>
                  Faturamento
                  <br />
                  entrega
                </p>
              </CheckStepByStepContainerBlocksBlockDescription>
            </CheckStepByStepContainerBlocksBlockSubtitle>

            <CheckStepByStepContainerBlocksBlockSubtitle>
              <CheckStepByStepContainerBlocksBlockDescription>
                <p>Produtos</p>
              </CheckStepByStepContainerBlocksBlockDescription>
            </CheckStepByStepContainerBlocksBlockSubtitle>

            <CheckStepByStepContainerBlocksBlockSubtitle>
              <CheckStepByStepContainerBlocksBlockDescription>
                <p>Frete</p>
              </CheckStepByStepContainerBlocksBlockDescription>
            </CheckStepByStepContainerBlocksBlockSubtitle>

            <CheckStepByStepContainerBlocksBlockSubtitle>
              <CheckStepByStepContainerBlocksBlockDescription>
                <p>Observações</p>
              </CheckStepByStepContainerBlocksBlockDescription>
            </CheckStepByStepContainerBlocksBlockSubtitle>

            <CheckStepByStepContainerBlocksBlockSubtitle>
              <CheckStepByStepContainerBlocksBlockDescription>
                <p>
                  Aprovação
                  <br />
                  Cliente
                </p>
              </CheckStepByStepContainerBlocksBlockDescription>
            </CheckStepByStepContainerBlocksBlockSubtitle>
          </CheckStepByStepContainerBlocksSubtitle>
        </div>
      </>
    );
  }
}

export default ScoreStepByStep;
